import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import ChangePassword from './ChangePassword';

function Layout({ children, user, onLogout }) {
  const location = useLocation();
  const [showChangePassword, setShowChangePassword] = useState(false);

  const navigation = [
    { name: 'Dashboard', href: '/dashboard', current: location.pathname === '/dashboard' },
    { name: 'Users', href: '/users', current: location.pathname === '/users' },
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      <nav className="bg-white shadow-sm">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="flex h-16 justify-between">
            <div className="flex">
              <Link to="/dashboard" className="flex flex-shrink-0 items-center">
                <img src="/logo.svg" alt="Terraback" className="h-8 w-auto" />
                <span className="ml-2 text-sm font-medium text-gray-500">Admin</span>
              </Link>
              <div className="hidden sm:-my-px sm:ml-6 sm:flex sm:space-x-8">
                {navigation.map((item) => (
                  <Link
                    key={item.name}
                    to={item.href}
                    className={`${
                      item.current
                        ? 'border-blue-500 text-gray-900'
                        : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700'
                    } inline-flex items-center border-b-2 px-1 pt-1 text-sm font-medium`}
                  >
                    {item.name}
                  </Link>
                ))}
              </div>
            </div>
            <div className="hidden sm:ml-6 sm:flex sm:items-center">
              <span className="text-sm text-gray-700 mr-4">
                Welcome, {user?.username}
              </span>
              <button
                onClick={() => setShowChangePassword(true)}
                className="text-sm text-gray-500 hover:text-gray-700 mr-4"
              >
                Change Password
              </button>
              <button
                onClick={onLogout}
                className="text-sm text-gray-500 hover:text-gray-700"
              >
                Sign out
              </button>
            </div>
          </div>
        </div>
      </nav>

      <div className="py-10">
        <main>
          <div className="mx-auto max-w-7xl sm:px-6 lg:px-8">
            {children}
          </div>
        </main>
      </div>

      <footer className="py-4 text-center text-xs text-gray-400">
        Admin Portal v{process.env.REACT_APP_VERSION || require('../../package.json').version}
      </footer>

      {showChangePassword && (
        <ChangePassword
          token={localStorage.getItem('adminToken')}
          apiBaseUrl="https://jaejtnxq15.execute-api.us-east-1.amazonaws.com/prod/v1"
          onClose={() => setShowChangePassword(false)}
        />
      )}
    </div>
  );
}

export default Layout;